import styled, { css } from "styled-components";

// ** Custom Components
import Text from "components/typography/Text";
import Block from "components/layout/Block";

// ** Icons Imports
import CaretUp from "components/icons/CaretUp";
import CaretDown from "components/icons/CaretDown";

const SelectorButtonStyled = styled.button`
	position: relative;
	cursor: pointer;
	white-space: normal;
	text-align: center;
	font-size: 1.1rem;
	line-height: 2rem;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: var(--dz-comp-auth-panel-box-shadow);
	opacity: 1;
	border-radius: var(--dz-ref-border-radius-1-50);
	margin: 0rem;
	width: 100%;
	background-color: var(--dz-sys-button-landing-secondary-background-color);
	color: var(--dz-sys-button-landing-secondary-text-color);
	padding: 0 0.5rem;
	height: 42px;

	button[disabled] {
		cursor: no-drop;
	}

	&:hover {
		background-color: var(
			--dz-sys-button-landing-secondary-background-color-hover
		);
	}

	${({ active }) =>
		active
			? css`
					z-index: 1;
					font-weight: bold;
					color: var(--dz-sys-button-landing-secondary-text-color);
					&:hover {
						background-color: var(
							--dz-sys-button-landing-secondary-background-color-hover
						);
					}
					background-color: var(
						--dz-sys-button-landing-secondary-background-color-active
					);
			  `
			: css`
					z-index: 2;
					&:hover {
						background-color: var(
							--dz-sys-button-landing-secondary-background-color-hover
						);
					}
					&:active {
						background-color: var(
							--dz-sys-button-landing-secondary-background-color-active
						);
					}
			  `}

	${({ isOpen }) =>
		isOpen &&
		css`
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
		`}
`;

// #####################################################

const selectorActivator = ({
	isOpen,
	toggle,
	triggerRef,
	hasSelected,
	displayText,
	label,
	style = { width: "33.33%" },
	disabled,
	reverse = true,
	...rest
}) => {
	return (
		<SelectorButtonStyled
			label={label}
			ref={triggerRef}
			onClick={toggle}
			color="whiteTrueAlways"
			dropdown
			disabled={disabled}
			active={isOpen || hasSelected}
			style={{
				...style,
				margin: 0,
			}}
			{...rest}
			register
			reverse={reverse}
			isOpen={isOpen}
		>
			<Block flex full justifyBetween>
				<Block>
					<Text px={2}>{displayText}</Text>
				</Block>
				<Block pr={1}>{isOpen ? <CaretUp /> : <CaretDown />}</Block>
			</Block>
		</SelectorButtonStyled>
	);
};

// #####################################################

export default selectorActivator;

// #####################################################
